import { render, staticRenderFns } from "./FundDetailsDrawer.vue?vue&type=template&id=62a59815"
import script from "./FundDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./FundDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports